import React from 'react';
import { formatCandidateCardStatus } from '../../utils/candidateCardStatusMapper';
import styles from './CandidateStatusBadge.module.css';

interface CandidateStatusBadgeProps {
  status: string;
  className?: string;
}

const CandidateStatusBadge: React.FC<CandidateStatusBadgeProps> = ({ status, className = '' }) => {
  if (!status) return null;

  const displayText = formatCandidateCardStatus(status);

  return <span className={`${styles.statusBadge} ${className}`}>{displayText}</span>;
};

export default CandidateStatusBadge;
